import React from "react";
import "../styles/AI4FinTech.css";

export default function AI4FinTech() {
  return (
    <div className="container AI4FinTech-container">
      <div className="AI4FinTech-title-container">
        <h1>Artificial Intelligence for FinTech (AI4FinTech)</h1>
        <h2>at 2023 AAAI Summer Symposium Series</h2>
      </div>
      <hr />
      <h3>Updates</h3>
      <p>
        April 12, 2023. General information on our symposium is available on
        this site.
      </p>
      <h3>Location</h3>
      <p>July 18-19, 2023, EXPO, Singapore</p>
      <h4>Introduction</h4>
      <p>
        Financial technology (FinTech) as an emerging field at the intersection
        of finance and information technology has become one of the hotspots in
        the financial industry and gained increasing attention. Particularly,
        with the advancement in artificial intelligence (AI), FinTech has
        further demonstrated its penetrability to all aspects of the global
        financial market, continuously changing the current financial landscape.
        Moreover, due to the complex dynamics, the financial market provides an
        ideal scenario for developing, deploying, and testing novel AI
        techniques for various financial applications, benefiting both the
        finance and AI communities.
      </p>
      <p>
        The AI4FinTech Symposium aims to bring together experts (academic
        researchers, industrial practitioners, and regulators) from the finance
        and AI community to exchange ideas and their works about AI for FinTech,
        ranging from theory to algorithms as well as various applications.
      </p>
      <p>
        The topics covered include but are not limited to: <br />
      </p>
      <ul>
        <li>Machine learning algorithms for financial applications</li>
        <li>Deep learning approaches for financial applications</li>
        <li>Reinforcement learning for financial decision-making problems</li>
        <li>Representation learning for financial applications</li>
        <li>Robust learning and control in financial applications </li>
        <li>Fairness and governance of AI in financial applications </li>
        <li>Data mining for financial applications </li>
        <li>Explainable AI for financial applications</li>
      </ul>
      <h3>Submission</h3>
      <strong>Deadline: </strong>May 10, 2023
      <br />
      <p>
        All papers are restricted to 2-6 pages in length, and in PDF format.
        Please format your paper using the AAAI 2023 Author Kit (
        <a href="https://aaai-23.aaai.org/aaai23call/">
          https://aaai-23.aaai.org/aaai23call/
        </a>
        ).{" "}
      </p>
      <p>
        <strong>Submission Site: </strong> TBD. <br />
      </p>
      <p>
        <strong>IMPORTANT NOTE: </strong>
        In this year, AAAI will publish proceedings for those authors wishing to
        be included. Please include a statement at the end of your paper to show
        whether you want to include your paper in the Proceeding (if no
        statement is made, your paper will not be included by default).
      </p>
      <h3>Registration</h3>
      <p>
        <strong>Deadline: </strong>June 30, 2023 <br />
        <strong>Registration link:</strong> TBD <br />
      </p>
      <h3>Schedule</h3>
      <p>TBD</p>
      <h3>Organizing Committee </h3>
      <p>
        Bo An, Professor, Nanyang Technological University, boan@ntu.edu.sg{" "}
        <br />
        Chen Ying, Associate Professor, National University of Singapore,
        matcheny@nus.edu.sg
        <br /> ZHU Feida, Associate Professor, Singapore Management University,
        fdzhu@smu.edu.sg
        <br />
      </p>
    </div>
  );
}
